import React from "react";

const BackIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0006 19.438L14.9556 20.5L7.28963 12.71C7.10513 12.5197 7.00195 12.2651 7.00195 12C7.00195 11.7349 7.10513 11.4803 7.28963 11.29L14.9556 3.5L16.0006 4.563L8.68263 12L16.0006 19.438Z"
        fill="black"
      />
    </svg>
  );
};

export default BackIcon;
